import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalCacheManager } from 'src/app/managers/local-cache.manager';
import { PurchaseOrderManagerService } from 'src/app/services/purchase-order/purchase-order-manager.service';
import { PurchaseOrderPaymentType } from 'src/app/services/purchase-order/purchase-order.model';

@Component({
  selector: 'ls-payment-types-selection',
  templateUrl: './payment-types-selection.component.html',
  styleUrl: './payment-types-selection.component.less'
})
export class PaymentTypesSelectionComponent {
  @Input() selectedPaymentTypes: PurchaseOrderPaymentType[];
  @Input() allowedCashAmount: number;
  @Output() selectedPaymentTypesChange: EventEmitter<PurchaseOrderPaymentType[]> = new EventEmitter<PurchaseOrderPaymentType[]>()

  userCurrency: string = LocalCacheManager.currency;
  constructor(public poManager: PurchaseOrderManagerService){
  }

  static paymentTypes = [
      { id: 'Cash', title: 'Cash', value: PurchaseOrderPaymentType.Cash },
      { id: 'Check', title: 'Check', value: PurchaseOrderPaymentType.Check },
      { id: 'Wire', title: 'Wire Transfer', value: PurchaseOrderPaymentType.WireTransfer },
    ];
  get paymentTypesInternal() {
    return PaymentTypesSelectionComponent.paymentTypes 
  }

  onSelectionChange(event: PurchaseOrderPaymentType[]) {
    let diff = this.paymentTypesInternal.filter(y => !event.includes(y.value));
    diff.forEach(x => {
      this.poManager.current['total' + x.id] = null;
    })
    this.selectedPaymentTypesChange.emit(event);
  }
}
